import { getContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_USER_ID } from './constants';

export const baseErrorEnrichment = () => {
    const { userId } = getContext();

    return {
        userId: userId || DEFAULT_USER_ID,
    };
};
